import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { Button, RadioButton, RadioButtonGroup } from '@ipc/ipc-components';
import moment, { max, min } from 'moment';
import PropTypes from 'prop-types';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class ExceptionalRouteLeadingCountTypeEntryDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      validDates: true,
      startDateErrorMessage: '',
      endDateErrorMessage: '',
      endDateNullable: this.isEndDateNullable(),
    };
  }

  componentDidMount() {
    this.onStartDateChange(this.state.startDate);
  }

  onInvalidDate = (message) => {
    this.setState({
      validDates: message === '',
    });
  }

  onStartDateChange = (newDate) => {
    let message;
    if (newDate === null) {
      message = 'Start date can not be empty';
    } else {
      const newMomentStartDate = moment(newDate).startOf('day');
      const newMomentEndDate = this.state.endDate === null ? moment(this.props.routeEndDate) : moment(this.state.endDate);

      message = this.props.leadingCountList.filter((leadingCount) => {
        if (leadingCount.id === null || this.state.id === leadingCount.id) {
          return null;
        }

        const startDate = moment(leadingCount.startDate).startOf('day');
        const endDate = leadingCount.endDate === null ? moment(this.props.routeEndDate) : moment(leadingCount.endDate).startOf('day');

        if (max(startDate, newMomentStartDate) <= min(endDate, newMomentEndDate)) {
          return leadingCount;
        }
        return null;
      }).length > 0 ? 'Route leading count periods should not be overlapped' : '';
    }
    this.setState({
      startDate: newDate,
      startDateErrorMessage: message,
    });
  }

  onEndDateChange = (newDate) => {
    let startDateErrorMessage = '';
    let endDateErrorMessage = '';
    if (!this.state.endDateNullable && newDate === null) {
      endDateErrorMessage = 'End date can not be empty';
    } else {
      const newMomentStartDate = moment(this.state.startDate);
      const newMomentEndDate = moment(newDate).startOf('day');

      startDateErrorMessage = this.props.leadingCountList.filter((leadingCount) => {
        if (leadingCount.id === null || this.state.id === leadingCount.id) {
          return null;
        }

        const startDate = moment(leadingCount.startDate).startOf('day');
        const endDate = leadingCount.endDate === null ? moment(this.props.routeEndDate) : moment(leadingCount.endDate).startOf('day');

        if (max(startDate, newMomentStartDate) <= min(endDate, newMomentEndDate)) {
          return leadingCount;
        }
        return null;
      }).length > 0 ? 'Route leading count periods should not be overlapped' : '';
    }
    this.setState({
      endDate: newDate,
      startDateErrorMessage,
      endDateErrorMessage,
    });
  }

  getMinDate = () => {
    const tomorrow = moment().add(1, 'day').startOf('day');
    return this.props.routeStartDate > tomorrow ? this.props.routeStartDate : tomorrow;
  }

  getMaxDate = () => (this.props.routeEndDate === null ? undefined : this.props.routeEndDate)

  isEndDateNullable = () => this.props.leadingCountList.filter((leadingCount) => leadingCount.endDate === null).length === 0

  isApplyEnabled = () => (this.state.validDates && this.state.startDateErrorMessage === '' && this.state.endDateErrorMessage === '');

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <div style={{ float: 'left' }}>
          <table className="operator-impc-detail" style={{ width: '80%' }}>
            <tbody>
              <tr>
                <td className="selected-impc">
                  Leading Count Start Date
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy"
                        margin="normal"
                        minDate={this.getMinDate()}
                        id="start-date"
                        value={this.state.startDate}
                        onChange={this.onStartDateChange}
                        onError={this.onInvalidDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <p style={{ color: 'red' }}>{this.state.startDateErrorMessage}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Leading Count End Date
                </td>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        variant="inline"
                        format="dd-MM-yyyy"
                        margin="normal"
                        minDate={this.state.startDate}
                        maxDate={this.getMaxDate()}
                        id="end-date"
                        value={this.state.endDate}
                        onChange={this.onEndDateChange}
                        onError={this.onInvalidDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <p style={{ color: 'red' }}>{this.state.endDateErrorMessage}</p>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Leading Count Type
                </td>
                <td className="selected-impc">
                  <RadioButtonGroup defaultValue="MAX_EDI_RFID">
                    <RadioButton value="MAX_EDI_RFID" label="Max EDI RFID" checked />
                  </RadioButtonGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
                </td>
                <td>
                  <Button
                    disabled={!this.isApplyEnabled()}
                    className={`primary-button-${!this.isApplyEnabled()}`}
                    onClick={() => this.props.onApply(this.state.id, this.state.startDate, this.state.endDate)}
                  >
                    APPLY
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Dialog>
    );
  }
}

ExceptionalRouteLeadingCountTypeEntryDialog.propTypes = {
  id: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  routeStartDate: PropTypes.string,
  routeEndDate: PropTypes.string,
  leadingCountList: PropTypes.arrayOf(PropTypes.object),
  onApply: PropTypes.func,
  closeDialog: PropTypes.func,
  openDialog: PropTypes.func,
};

export default ExceptionalRouteLeadingCountTypeEntryDialog;
